import styled from 'styled-components'

export const UserWrapper = styled('div')<{ canRemove?: boolean }>`
  align-items: center;
  display: flex;
  flex-direction: row;
  margin-top: 16px;

  & > div {
    flex: 1;
  }

  & > div:first-child {
    margin-right: 16px;
    max-width: 60%;
  }

  svg {
    margin-left: 0 !important;
  }
`

export const Title = styled.div`
  margin-top: 16px;
`
